export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
  'screen-1366': 1366
}

// 生成颜色
export const colors = {
  primaryColor: 'rgba(var(--primary-6))',
  colorGreen: '#00DCA3',
  colorYellow: '#FFCE1E',
  colorBlue: '#3AADFF',
  colorSkyBlue: '#2BF1FF',
  colorOrange: '#FF8D34',
  'text-color-1': 'rgba(0,0,0,0.85)',
  'text-color-2': 'rgba(0,0,0,0.65)'
}
